import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

const handleError = (error: HttpErrorResponse): Observable<never> => {
  let message = '';

  if (error.status === 0) {
    // A client-side or network error occurred. Handle it accordingly.
    message = 'An error occurred; please check your connection and try again.';

    console.error('An error occurred:', error.error);
  } else {
    // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong.
    message = 'An error occurred; please try again later.';

    console.error(
      `Backend returned code ${error.status}, body was: `,
      error.error
    );
  }

  // Return an observable with a user-facing error message.
  return throwError(() => new Error(message));
};

/**
 * Get a user-facing error message from requests not returning an observable.
 *
 * @param error Error object.
 * @returns User-facing error message.
 */
export const handleErrorMessage = (error: unknown): string => {
  let message = 'An error occurred; please try again later.';

  if (error instanceof Error) {
    message = error.message;
  }

  return message;
};

export default handleError;
